<template>
  <div>
    <div class="pa-4 d-flex justify-center" v-if="data.objects.length == 0">
      <strong>{{ $t('Nenhum registro encontrado') }}</strong>
    </div>

    <strong class="ma-2">
      {{ total ? total.toInstLocale() : '0,00' }}
    </strong>

    <v-simple-table class="main-table" dense v-if="data.objects.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">{{ $t('Setor') }}</th>
            <th class="text-left">{{ $t('Valor (Serviço)') }}</th>
            <th class="text-left">{{ $t('Valor (Peça)') }}</th>
            <th class="text-left">{{ $t('Valor total') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data.objects" :key="item.identification">
            <td></td>
            <td>{{ item.departmentName }}</td>
            <td>
              {{ item.totalService ? item.totalService.toInstLocale() : '$0' }}
            </td>
            <td>
              {{ item.totalPart ? item.totalPart.toInstLocale() : '' }}
            </td>
            <td>
              {{ item.totalCosts ? item.totalCosts.toInstLocale() : '' }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pagination">
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'EquipStoppedComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      apiService: new ApiService(),
      total: 0,
      filter: {
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionId: 1,
      },
      data: {
        objects: [],
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/yyyy hh:mm')
      } else return 'Sem registro'
    },

    list() {
      this.apiService
        .post('dash/executed-costs', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.data = response.content.data
          this.totalPages = response.content.data.pager.totalPages
        })
    },
  },
}
</script>

<style scoped></style>
